import "../../styles/commons.css";
const Divider = () => {
  return <div className="divider-custom" />;
};

export default Divider;
